import { CalendarToday } from '@mui/icons-material'
import { styled } from '@mui/material/styles'

export const CalendarIcon = styled(CalendarToday)(({ theme }) => ({
  fontSize: 'large',
  color: theme.palette.primary.main,
}))
